import script from "./UnitPics.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitPics.vue?vue&type=script&setup=true&lang=js"

import "./UnitPics.vue?vue&type=style&index=0&id=3db4a7bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db4a7bc"]])

export default __exports__